<template>
  <div v-if="numberOfRooms" data-test-attr :class="$style.item">
    <div :class="$style.label">
      {{ t('ROOMS') }}
    </div>
    <div :class="$style.value">
      <div :class="$style.valueIcon">
        <HgIcon icon="HouseOutline" size="large" />
      </div>
      {{ numberOfRooms }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { HgIcon, hgNumber, HgSupportedLanguage } from '@smg-real-estate/domus';
import { Listing } from '@smg-real-estate/hg-rets-schema';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

defineOptions({
  name: 'SpotlightAttributesNumberOfRooms',
});

interface Props {
  listing: Listing;
}
const props = defineProps<Props>();

const numberOfRooms = computed((): string | undefined => {
  if (!props.listing.characteristics?.numberOfRooms) {
    return;
  }

  return hgNumber(props.listing.characteristics.numberOfRooms, locale.value as HgSupportedLanguage);
});
</script>

<style module lang="scss">
@import './SpotlightAttributes';
</style>
